import { Component, OnInit,Input } from '@angular/core';
import * as firebase from 'firebase'
import { Router } from '@angular/router';
import {GranServicioDePTWService} from '../gran-servicio-de-ptw.service'

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {

  

  paso1 ={status:"a ver",icono:"warning",disabled:false,color:"naranja"};
  paso2 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"};
  paso3 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  paso3A ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  paso4 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  paso5 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  paso6 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  paso7 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}

  constructor(private router:Router,public granServicioDePTWService:GranServicioDePTWService) {
   }

  ngOnInit() {
    if(this.granServicioDePTWService.solicitudEsNueva==false){
      this.actualizar()
    }
    
    // this.paso1 ={status:"pendiente",icono:"warning",disabled:false,color:"naranja"}
    // this.paso2 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
    // this.paso3 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
    // this.paso4 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
    // this.paso5 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
    // this.paso6 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
    // this.paso7 ={status:"pendiente",icono:"help-circle",disabled:true,color:"azulclarito"}
  }


  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 


actualizar(){
  console.log("actualizar triggered")
let query = firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud)
  query.get().then((doc)=>{
    this.verificapasos(doc)

  })
 }


verificapasos(doc){

  if(doc.data().objetoPasosCompletados.paso1 =='ok'){
    console.log("compara status 1");
      this.paso1.disabled=false;
      this.paso1.status="OK" ;
      this.paso1.icono="checkmark-circle";
      this.paso1.color="verde";
      
      this.paso2.disabled=false;
      this.paso2.color="naranja";
      this.paso2.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso2 =='ok'){
      console.log("compara status 2");
      this.paso2.disabled=false;
      this.paso2.status="OK"
      this.paso2.icono="checkmark-circle"
      this.paso2.color="verde"

      this.paso3.disabled=false
      this.paso3.color="naranja"
      this.paso3.icono="warning"
    }
    if(doc.data().objetoPasosCompletados.paso3 =='ok'){
      console.log("compara status 3")
      this.paso3.disabled=false;
      this.paso3.status="OK" ;
      this.paso3.icono="checkmark-circle";
      this.paso3.color="verde";

      this.paso3A.disabled=false;
      this.paso3A.color="naranja";
      this.paso3A.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso3A != undefined && doc.data().objetoPasosCompletados.paso3A =='ok'){
      console.log("compara status 3A")
      this.paso3A.disabled=false;
      this.paso3A.status="OK" ;
      this.paso3A.icono="checkmark-circle";
      this.paso3A.color="verde";

      this.paso4.disabled=false;
      this.paso4.color="naranja";
      this.paso4.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso4 =='ok'){
      console.log("compara status 4");
      this.paso4.disabled=false;
      this.paso4.status="OK" ;
      this.paso4.icono="checkmark-circle";
      this.paso4.color="verde";

      this.paso5.disabled=false;
      this.paso5.color="naranja";
      this.paso5.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso5 =='ok'){
      console.log("compara status 5");
      this.paso5.disabled=false;
      this.paso5.status="OK" ;
      this.paso5.icono="checkmark-circle";
      this.paso5.color="verde";

      this.paso6.disabled=false;
      this.paso6.color="naranja";
      this.paso6.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso6 =='ok'){
      console.log("compara status 6");
      this.paso6.disabled=false;
      this.paso6.status="OK" ;
      this.paso6.icono="checkmark-circle";
      this.paso6.color="verde";

      this.paso7.disabled=false;
      this.paso7.color="naranja";
      this.paso7.icono="warning";
    }
    if(doc.data().objetoPasosCompletados.paso6 =='ok'){
      console.log("compara status 7");
      this.paso7.disabled=false;
      this.paso7.status="OK" ;
      this.paso7.icono="checkmark-circle";
      this.paso7.color="verde";

      this.paso7.disabled=false;
      this.paso7.color="naranja";
      this.paso7.icono="warning";
    }
    

}



}//fin de clase
